import type {
    DocumentData,
    QuerySnapshot,
} from 'firebase/firestore'

/** Document record with uid merged from Firestore document id. */
export type DocumentRecord = DocumentData & { uid: string }

/**
 * Process query snapshot into result data.
 *
 * @param querySnapshot - Firestore QuerySnapshot to process
 * @returns Array of document data objects with `uid` set to the document id
 */
export const processQuerySnapshot = (querySnapshot: QuerySnapshot<DocumentData>): DocumentRecord[] => {
    const result: DocumentRecord[] = []
    querySnapshot.forEach(document => {
        result.push({
            uid: document.id,
            ...document.data(),
        })
    })

    return result
}

/**
 * Process query snapshot into result data and returns first item if there is any.
 *
 * @param querySnapshot - Firestore QuerySnapshot to process
 * @returns First document record, or null if snapshot is empty
 */
export const processQuerySnapshotAndGetFirst = (
    querySnapshot: QuerySnapshot<DocumentData>,
): DocumentRecord | null => {
    const processedQuerySnapshot = processQuerySnapshot(querySnapshot)
    return processedQuerySnapshot?.[0] || null
}

/**
 * Process query snapshot into array of id items.
 *
 * @param querySnapshot - Firestore QuerySnapshot to process
 * @returns Array of document id strings
 */
export const processQuerySnapshotUid = (querySnapshot: QuerySnapshot<DocumentData>): string[] => {
    const result: string[] = []

    querySnapshot.forEach(document => {
        result.push(document.id)
    })

    return result
}
